import * as React from "react";
import {
  Box,
  Button,
  Heading,
  Input,
  Stack,
  Text,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { HiShieldCheck } from "react-icons/hi";
import { setInLocalStorage } from "../../utils/helpers";

export const Newsletter = () => {
  const [email, setEmail] = React.useState("");
  const [emailFromLocalStorage, setEmailFromLocalStorage] = React.useState<
    string | null
  >(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      if (localStorage.getItem("subscribedEmail") !== null) {
        setEmailFromLocalStorage(localStorage.getItem("subscribedEmail"));
      }
    }
  }, []);

  const handleSubscribe = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`https://api.tweetbutler.com/discovr/request?email=${email}`, {
        method: "POST"
      });
      const data = await response.json();

      if (data.success === 1) {
        setInLocalStorage("subscribedEmail", email);
        setEmailFromLocalStorage(email);
      }
    } catch (e) {
      console.error("Error happened in subscribing to email list: ", e);
      toast.error("Error happened in subscribing to email list: " + e.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Box as="section" bg={mode("gray.100", "gray.700")} py="12">
      <Box
        textAlign="center"
        bg={mode("white", "gray.800")}
        shadow="lg"
        maxW={{ base: "xl", md: "3xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
        py="12"
        rounded="lg"
      >
        <Box maxW="md" mx="auto">
          <Text
            color={mode("green.600", "green.600")}
            fontWeight="bold"
            fontSize="sm"
            letterSpacing="wide"
          >
            1,000+ PEOPLE ALREADY JOINED ❤️️
          </Text>
          <Heading mt="4" fontWeight="extrabold">
            Get useful twitter growth tips and project updates
          </Heading>
          <Box mt="6">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                // your subscribe logic here
              }}
            >
              <Stack>
                <Input
                  isDisabled={isLoading || !!emailFromLocalStorage}
                  aria-label="Enter your email"
                  placeholder="Enter your email to join"
                  rounded="base"
                  value={emailFromLocalStorage || email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  isDisabled={email.length <= 4 || !!emailFromLocalStorage}
                  type="submit"
                  w="full"
                  colorScheme="blue"
                  size="lg"
                  textTransform="uppercase"
                  fontSize="sm"
                  fontWeight="bold"
                  isLoading={isLoading}
                  onClick={() => handleSubscribe()}
                >
                  {emailFromLocalStorage ? "Joined" : "Join"}
                </Button>
              </Stack>
            </form>
            <Text color={mode("gray.600", "gray.400")} fontSize="sm" mt="5">
              <Box
                aria-hidden
                as={HiShieldCheck}
                display="inline-block"
                marginEnd="2"
                fontSize="lg"
                color={mode("green.600", "green.600")}
              />
              No spams. We&apos;re only send you relevant content
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
